module.exports = __webpack_public_path__ + "media/images/shop-dashboard-background-mobile-8e3858bfe9b56d2e6c1c352ccdc47dc2.png";